import { BookingRemarks } from '@models/booking-remarks.model';
import { IBookingModel } from '@services/api/booking/booking-model.interface';

/** A külső rendszer a sortörést néha HTML-ként küldi (`<br />`); minden írásmódját illeszti. */
const HTML_LINE_BREAK = /<br\b[^>]*>/gi;

const meaningfulText = (value: string | null | undefined): string | undefined =>
  value?.replace(HTML_LINE_BREAK, '\n').trim() || undefined;

/**
 * A foglalás külső rendszerből érkező megjegyzései megjelenítésre készen.
 * A `<br>` tagek sortöréssé válnak, más HTML-t nem értelmezünk (a szöveg sima szövegként jelenik meg).
 * Az üres vagy csak szóközből álló szöveg nem számít megjegyzésnek; ha egyik sincs, `undefined`,
 * így a felület semmit nem jelez.
 */
export function toBookingRemarks(booking: Pick<IBookingModel, 'comment' | 'customer_remarks'>): BookingRemarks | undefined {
  const customerRemarks = meaningfulText(booking.customer_remarks);
  const comment = meaningfulText(booking.comment);
  if (!customerRemarks && !comment) {
    return undefined;
  }
  return { customerRemarks, comment };
}
